module.exports = fox._r("images/spring18/gift-63.png", __webpack_public_path__ + "_/_/_/_/common/liveshow/images/spring18/gift-63.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/images/spring18/gift-63.png
// module id = 264
// module chunks = 4